export const PostingGroupRoute = {
  path: '/Posting/PostingGroups/:id',
  load: () => import('./PostingGroup'),
  protected: true,
};
